import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  OnDestroy
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { Province } from '@ascschool/model/category/province.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { BaocaoService } from '@ascschool/services/baocao/baocao.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { EducationalStatusService } from '@ascschool/services/category/educational-status.service';
import { LevelService } from '@ascschool/services/category/level.service';
import { LivingConditionService } from '@ascschool/services/category/living-condition.service';
import { ModesOfEducationService } from '@ascschool/services/category/modese-of-education.service';
import { NeedOfDisabilityService } from '@ascschool/services/category/need-of-disability.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { StudyModeService } from '@ascschool/services/category/study-mode.service';
import { TypeOfEducationInvolveService } from '@ascschool/services/category/type-of-education-involve.service';
import { TypeOfPersonnelService } from '@ascschool/services/category/type-of-personnel.service';
import { TypeOfDisabilityService } from '@ascschool/services/category/typeofdisability.service';
import { TypeofEducationService } from '@ascschool/services/category/typeofeducation.service';
import { TypeOfSchoolService } from '@ascschool/services/category/typeofschool.service';
import { WardService } from '@ascschool/services/category/ward.service';
import { SchoolLevelService } from '@ascschool/services/school/school-level.service';
import { StudentService } from '@ascschool/services/school/student.service';
import { StaffService } from '@ascschool/services/user/staff.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { Observable,Subject } from 'rxjs';
import { map,takeUntil} from 'rxjs/operators';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { element } from 'protractor';

@Component({
  selector: 'app-thong-ke-gd-nkt',
  templateUrl: './thong-ke-gd-nkt.component.html',
  styleUrls: ['./thong-ke-gd-nkt.component.scss']
})
export class ThongKeGdNktComponent implements OnInit,OnDestroy {
  constructor(
    private cdRef: ChangeDetectorRef,
    public _authService: AuthService,
    public sizePageService: SizePageService,
    private authQuery: AuthQuery,
    public utilService: UtilsService,
    private service: BaocaoService,
    private staffService: StaffService,
    private studentService: StudentService,
    private typeOfDisabilityservice: TypeOfDisabilityService,
    private caDisEducationalStatusesService: EducationalStatusService,
    private disModesOfEducationService: ModesOfEducationService,
    private disStudyModeService: StudyModeService,
    private caDisNeedOfDisabilitysService: NeedOfDisabilityService,
    private disProvincesService: ProvinceService,
    private districtService: DistrictService,
    private wardService: WardService,
    private levelService: LevelService,
  ) {}
  get breadcrumbs(): string[] {
    return ['Báo cáo tổng hợp'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content(content: ElementRef) {
    if (content) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content;
    }
  }
  @ViewChild('pageHeaderTable2', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable2 = content2;
    }
  }
  @ViewChild('pageHeaderTable3', { static: false }) set content3(content3: ElementRef) {
    if (content3) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable3 = content3;
    }
  }
  $unSubcsribe = new Subject();
  widthConfig = [];
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm: string = '';
  pageIndex: number = 1;
  province = new Province();
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[0];
  loading: boolean = true;
  Total: number = 0;
  thongtinCSGDList: any;
  dataTable: any[] = [];
  year:any = "";
  firstRowOnPage: any;
  numberRow: number = 0;
  dataList: any;
  width: number;
  numberControl: number;
  dataDkt: any[] = [];
  dataHth: any[] = [];
  dataMdkt: any[] = [];
  dataNcht: any[] = [];
  dataPtgd: any[] = [];
  dataTtgd: any[] = [];
  private elementPageHeaderTable: ElementRef;
  private elementPageHeaderTable2: ElementRef;
  private elementPageHeaderTable3: ElementRef;
  getProvinceACFn: (value: any) => Observable<any>;
  ProvinceSubscription: any;
  ProvinceControl = new FormControl();
  @ViewChild('pageSample8', { static: false }) elementPageSample8: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  @ViewChild('Table', { static: false }) tableElement: NzTableComponent;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation: number = 50;
  isCollapse = true;
  getDisStudentsACFn: (value: any) => Observable<any>;
  disStudentsSubscription: any;
  disStudentsControl = new FormControl();
  getDisTypeOfDisabilitysACFn: (value: any) => Observable<any>;
  disTypeOfDisabilitysSubscription: any;
  disTypeOfDisabilitysControl = new FormControl();
  getCaDisEducationalStatusessACFn: (value: any) => Observable<any>;
  caDisEducationalStatusesSubscription: any;
  caDisEducationalStatusesControl = new FormControl();
  getDisModesOfEducationACFn: (value: any) => Observable<any>;
  disModesOfEducationSubscription: any;
  disModesOfEducationControl = new FormControl();
  getDisStudyModeACFn: (value: any) => Observable<any>;
  disStudyModeSubscription: any;
  disStudyModeControl = new FormControl();
  getCaDisNeedOfDisabilitysACFn: (value: any) => Observable<any>;
  caDisNeedOfDisabilitysSubscription: any;
  caDisNeedOfDisabilitysControl = new FormControl();
  getDisProvincesACFn: (value: any) => Observable<any>;
  DisProvincesSubscription: any;
  DisProvincesControl = new FormControl();
  getDistrictACFn: (value: any) => Observable<any>;
  DistrictSubscription: any;
  DistrictControl = new FormControl();
  getDisWardACFn: (value: any) => Observable<any>;
  DisWardSubscription: any;
  DisWardControl = new FormControl();
  getLevelACFn: (value: any) => Observable<any>;
  LevelSubscription: any;
  LevelControl = new FormControl();
  sortNameFn = (a: Province, b: Province) => a.provinceName.localeCompare(b.provinceName);
  ngOnInit() {
    this.commonFilter.Gender = -1;
    this.commonFilter.DisDisabilityCertificateType = -1;
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[0];
    this.reload();
    this.loadDisStudents();
    this.loadDisTypeOfDisabilitys();
    this.loadCaDisEducationalStatuses();
    this.loadDisModesOfEducation();
    this.loadDisStudyMode();
    this.loadCaDisNeedOfDisabilitys();
    this.loadDisProvinces();
    this.loadLevel();
    this.maxHeight = window.innerHeight;
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
  }
  reload() {
    const _this = this;
    this.loading = true;
    _this.dataTable = [];
    this.commonFilter.year = this.year;
    this.commonFilter.TypeOfDisabilityId
    this.service.getRpCsgdTknkt(this.commonFilter).pipe(takeUntil(this.$unSubcsribe)).subscribe(
      (response: any) => {
        this.handlingData(response);
        this.firstRowOnPage = (response.dataTable && response.dataTable.firstRowOnPage) ? response.dataTable.firstRowOnPage : 0;
        this.Total = (response.dataTable && response.dataTable.rowCount) ? response.dataTable.rowCount : 0;
        setTimeout(() => {
          _this.loading = false;
        },500);
      },
      (err: any) => {
        _this.dataTable = [];
        _this.loading = false;
      }
    );
  }
  handlingData(response){
    // let keys = Object.keys(response.dataTable.results[0]);
    let arrayWidth = ['50px', '200px', '70px', '70px', '60px', '80px' ];
    let arrayWidth2 = ['200px', '80px', '200px', '70px', '70px', '70px', '200px', '150px', '70px', '70px', '70px', '100px', '100px' ];

    // keys.forEach(element =>{
    //   if(element === 'fullName' || element === 'tutorName' || element === 'staffFullName' || element === 'staffQualificationName' || element === 'tutorEducationLevelName'){
    //     arrayWidth.push('200px');
    //   }else{
    //     arrayWidth.push('80px');
    //   }
    // });
    let numberRow = response.dataDkt.length + response.dataMdkt.length + response.dataNcht.length + response.dataPtgd.length + response.dataTtgd.length + response.dataHth.length;
    for(let i = 0; i < numberRow; i++){
      arrayWidth.push('70px');
    }
    this.widthConfig = arrayWidth.concat(arrayWidth2);
    this.dataDkt = response.dataDkt.map((dkt)=>{
      var rObj = { id :  dkt.id = dkt.id.toString(), name: dkt.typeOfDisabilityName };
      return rObj;
    });

    this.dataHth = response.dataHth;
    this.dataMdkt = response.dataMdkt;
    this.dataNcht = response.dataNcht;
    this.dataPtgd = response.dataPtgd;
    this.dataTtgd = response.dataTtgd;
    response.dataTable.results.forEach(element => {
      if(element.typeOfDisabilityIds !== null){
        element.typeOfDisabilityIds = element.typeOfDisabilityIds.split(';');
      }
    });
    this.dataTable = response.dataTable.results;


  }
  exportExcel(){
    this.commonFilter.year = this.year;
    this.service.exportRpCsgdTknkt(this.commonFilter).subscribe((data : any) => {
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'csgdtknkt.xlsx';
      link.click();
    });
  }
  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
    this.checkCaculateSize();
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
     setTimeout(() => {
      this.checkCaculateSize();
     }, 500);
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'],
      label: 'Help',
      description: 'Cmd + b',
      command: (e) => console.log('alt + n')
      ,
      preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateSize() {
    setTimeout(() => {
      this.height = this.heightfnc();

      // if(this.numberRow === 0 ){
      //   this.width = 3500;
      // }else{
      //   this.width = 210 + (110 * this.numberRow);
      // }
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.elementPageHeaderTable2,
      this.elementPageHeaderTable3,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.checkCaculateSize();
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateSize();
  }
  loadDisStudents() {
    // tslint:disable-next-line: max-line-length
    this.getDisStudentsACFn = (value: any) => this.studentService.get({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.fullName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.disStudentsSubscription) { this.disStudentsSubscription = this.disStudentsControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'disStudentsId', this.disStudentsControl.value);
    });
    }
  }
  changeDisStudentsACFn(control: FormControl) {
    this.disStudentsControl = control;
  }

  loadDisTypeOfDisabilitys() {
    // tslint:disable-next-line: max-line-length
    this.getDisTypeOfDisabilitysACFn = (value: any) => this.typeOfDisabilityservice.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfDisabilityName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.disTypeOfDisabilitysSubscription) { this.disTypeOfDisabilitysSubscription = this.disTypeOfDisabilitysControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'TypeOfDisabilityId', this.disTypeOfDisabilitysControl.value);
    });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisTypeOfDisabilitysACFn(control: FormControl) {
    this.disTypeOfDisabilitysControl = control;
  }

  loadCaDisEducationalStatuses() {
    // tslint:disable-next-line: max-line-length
    this.getCaDisEducationalStatusessACFn = (value: any) => this.caDisEducationalStatusesService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.caDisEducationalStatusesSubscription) { this.caDisEducationalStatusesSubscription = this.caDisEducationalStatusesControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'EducationalStatusId', this.caDisEducationalStatusesControl.value);
    });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeCaDisEducationalStatuses(control: FormControl) {
    this.caDisEducationalStatusesControl = control;
  }

  loadDisModesOfEducation() {
    // tslint:disable-next-line: max-line-length
    this.getDisModesOfEducationACFn = (value: any) => this.disModesOfEducationService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.disModesOfEducationSubscription) { this.disModesOfEducationSubscription = this.disModesOfEducationControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'ModesOfEducationId', this.disModesOfEducationControl.value);
    });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisModesOfEducation(control: FormControl) {
    this.disModesOfEducationControl = control;
  }

  loadDisStudyMode() {
    // tslint:disable-next-line: max-line-length
    this.getDisStudyModeACFn = (value: any) => this.disStudyModeService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.disStudyModeSubscription) { this.disStudyModeSubscription = this.disStudyModeControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'StudyModeId', this.disStudyModeControl.value);
    });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisStudyMode(control: FormControl) {
    this.disStudyModeControl = control;
  }
  loadCaDisNeedOfDisabilitys() {
    // tslint:disable-next-line: max-line-length
    this.getCaDisNeedOfDisabilitysACFn = (value: any) => this.caDisNeedOfDisabilitysService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.caDisNeedOfDisabilitysSubscription) { this.caDisNeedOfDisabilitysSubscription = this.caDisNeedOfDisabilitysControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'NeedOfDisabilityId', this.caDisNeedOfDisabilitysControl.value);
    });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeCaDisNeedOfDisabilitys(control: FormControl) {
    this.caDisNeedOfDisabilitysControl = control;
  }
  loadDisProvinces() {
    // tslint:disable-next-line: max-line-length
    this.getDisProvincesACFn = (value: any) => this.disProvincesService.getProvinceSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.DisProvincesSubscription) { this.DisProvincesSubscription = this.DisProvincesControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.DisProvincesControl.value);
    });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisProvincesACFn(control: FormControl) {
    this.DisProvincesControl = control;
    if (this.DisProvincesControl){
      this.loadDistrict();
      this.DistrictControl.setValue(null);
    }
  }
  loadDistrict() {
    // tslint:disable-next-line: max-line-length
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({ searchTerm: value, ProvinceId: this.valueIfHas(this.DisProvincesControl), PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.DistrictSubscription) { this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
    });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDistrictACFn(control: FormControl) {
    this.DistrictControl = control;
    if(this.DistrictControl){
      this.loadDisWard();
      this.DisWardControl.setValue(null);
    }
  }
  loadDisWard() {
    // tslint:disable-next-line: max-line-length
    this.getDisWardACFn = (value: any) => this.wardService.getWardSelectPaging({ searchTerm: value, DistrictId: this.valueIfHas(this.DistrictControl), PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.wardName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.DisWardSubscription) { this.DisWardSubscription = this.DisWardControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'WardId', this.DisWardControl.value);
    });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisWardACFn(control: FormControl) {
    this.DisWardControl = control;
  }
  loadLevel() {
    // tslint:disable-next-line: max-line-length
    this.getLevelACFn = (value: any) => this.levelService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.levelName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.LevelSubscription) { this.LevelSubscription = this.LevelControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'LevelId', this.LevelControl.value);
    });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeLevelACFn(control: FormControl) {
    this.LevelControl = control;
  }
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value !== 'string') { return control.value.id; }
    return '';
  }
  clear(){
    delete this.commonFilter.FullName;
    this.commonFilter.Gender = -1;
    delete this.commonFilter.year;
    this.commonFilter.DisDisabilityCertificateType = -1;
    this.DisProvincesControl.setValue(null);
    this.DistrictControl.setValue(null);
    this.DisWardControl.setValue(null);
    this.disStudentsControl.setValue(null);
    this.disTypeOfDisabilitysControl.setValue(null);
    this.caDisEducationalStatusesControl.setValue(null);
    this.disModesOfEducationControl.setValue(null);
    this.disStudyModeControl.setValue(null);
    this.caDisNeedOfDisabilitysControl.setValue(null);
    this.LevelControl.setValue(null);
    this.search();
  }
  ngOnDestroy(): void {
    this.$unSubcsribe.next();
    this.$unSubcsribe.complete();
}
}
